export default __webpack_public_path__ + "static/media/leornardo-oliveira.0dc7c9d1.jpg";